import React, { useEffect } from "react"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useCurrentUser } from "#/components/context/user/UserContext"
import useBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { ProgramType } from "#/lib/carrot-api/types/Benefit"

export function MedicalEntryDecisionStep(): JSX.Element {
  const { isUsa } = useCurrentUser()
  const benefitQuery = useBenefit()
  const isEngage = benefitQuery.data?.program?.type === ProgramType.WTW_ENGAGE
  const { send } = useStateMachine()

  useEffect(() => {
    if (benefitQuery.data) {
      send(isUsa && !isEngage ? "YES" : "NO")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- See https://carrotfertility.atlassian.net/wiki/spaces/PE/pages/2050295461/Remove+Build+Warnings#react-hooks%2Fexhaustive-deps
  }, [benefitQuery.data])
  return <></>
}

export const PreservationMedEntryStep = MedicalEntryDecisionStep
export const AssistedReproductionMedEntryStep = MedicalEntryDecisionStep
export const AttemptingToGetPregnantMedEntryStep = MedicalEntryDecisionStep
export const CurrentlyPregnantMedEntryStep = MedicalEntryDecisionStep
export const MenopauseMedEntryStep = MedicalEntryDecisionStep
export const LowTestosteroneMedEntryStep = MedicalEntryDecisionStep
export const ExploringMedEntryStep = MedicalEntryDecisionStep
